import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
export interface MobileBottomBarProps {
  children?: any;
}
export const MobileBottomBar: React.FC<MobileBottomBarProps> = props => {
  const $ = _c(5);
  const [isVisible, setIsVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 50) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = isVisible ? "0" : "-150px";
  let t3;
  if ($[2] !== props.children || $[3] !== t2) {
    t3 = <Box bgColor="colorPalette.emphasized" bottom={t2} boxShadow="0 0 30px rgba(0, 0, 0, 0.5)" left="0" position="fixed" right="0" transition="bottom 0.3s ease-out" zIndex={100}>{props.children}</Box>;
    $[2] = props.children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};